import LinkedInLogo from '@/assets/linkedin-logo.svg';


export default function (provider) {
  return (
    <button className="bg-cyan-700  hover:bg-cyan-800 flex flex-row justify-between items-center shadow-sm p-2 w-full text-white mb-2 cursor-pointer rounded"
    >
      <div className="flex flex-row items-center">
        <img src={LinkedInLogo.src} alt="GoogleLoginButton" width="35px" height="35px" />
        <span className={"ms-3"}>Log in with LinkedIn</span>
      </div>
      <i className="mio">arrow_forward_ios</i>
    </button>

  );
}
//style={{ backgroundColor: 'rgb(26, 129, 185)' }}